import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Trophy, Users, MessageSquare, Boxes } from 'lucide-react';

export const Footer = () => {
  // Chat sidebar her sayfada lokal state ile yönetiliyor; footer global olduğu için
  // gerçek DOM'daki sidebar'ı izleyip açık/kapalı durumuna göre kayıyoruz.
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const detect = () => {
      const el = document.querySelector('[data-testid="chat-sidebar"]');
      // Sidebar mevcut ve görünür konumdaysa (kapalıyken '-translate-x-full' alır) chat açık demektir.
      const open = !!el && !el.className.includes('-translate-x-full');
      setChatOpen(open); // aynı değerde React zaten render etmez
    };
    detect();
    const observer = new MutationObserver(detect);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => observer.disconnect();
  }, []);

  return (
    <footer className={`border-t border-[#2A2D31] bg-[#0B0C0E] pt-12 pb-8 mt-12 relative z-10 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[300px] lg:pl-[330px]' : ''}`}>
      <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 mb-1">
              <img
                src="/logo.png"
                alt="BloxBets"
                className="w-9 h-9 object-contain drop-shadow-[0_0_10px_rgba(176,89,232,0.5)]"
              />
              <span className="font-heading font-black text-2xl text-white tracking-widest">BLOX<span className="text-[#B059E8]">BETS</span></span>
            </div>
            <p className="text-zinc-500 text-xs leading-relaxed font-medium">
              The fairest Murder Mystery 2 social casino experience. Play all your favorite games for fun with your site balance. BloxBets.com
            </p>
            <div className="text-zinc-500 text-xs flex flex-col gap-1 mt-2 font-medium">
              <span className="flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> support@bloxbets.com</span>
            </div>

            <div className="mt-4 flex items-start gap-4 p-4 bg-[#15171a] rounded-xl border border-[#2A2D31]">
              <div className="w-10 h-10 rounded-full bg-[#1a0d0d] border border-red-500/20 flex items-center justify-center flex-shrink-0">
                <span className="text-red-500 font-black text-sm">18+</span>
              </div>
              <div className="text-[10px] text-zinc-500 leading-relaxed font-medium">
                By accessing this site, you confirm that <strong className="text-zinc-300">you are over 18.</strong><br />
                Have a Gaming Problem? <a href="https://discord.gg/bloxbets" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#c98bf0] transition-colors">Reach out for help</a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-zinc-600 font-black uppercase tracking-widest text-xs mb-5">Information</h3>
            <ul className="space-y-3 text-sm text-zinc-400 font-medium">
              <li><Link to="/fairness" className="hover:text-[#c98bf0] transition-colors">Fairness</Link></li>
              <li><a href="https://discord.gg/bloxbets" target="_blank" rel="noopener noreferrer" className="hover:text-[#c98bf0] transition-colors">Terms of Service</a></li>
              <li><a href="https://discord.gg/bloxbets" target="_blank" rel="noopener noreferrer" className="hover:text-[#c98bf0] transition-colors">Privacy Policy</a></li>
              <li><a href="https://discord.gg/bloxbets" target="_blank" rel="noopener noreferrer" className="hover:text-[#c98bf0] transition-colors">Rules</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-zinc-600 font-black uppercase tracking-widest text-xs mb-5">Games</h3>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm text-zinc-400 font-medium">
              <li><Link to="/cases" className="hover:text-[#c98bf0] transition-colors">Cases</Link></li>
              <li><Link to="/dice" className="hover:text-[#c98bf0] transition-colors">Dice</Link></li>
              <li><Link to="/battles" className="hover:text-[#c98bf0] transition-colors">Case Battles</Link></li>
              <li><Link to="/mines" className="hover:text-[#c98bf0] transition-colors">Mines</Link></li>
              <li><Link to="/crash" className="hover:text-[#c98bf0] transition-colors">Crash</Link></li>
              <li><Link to="/jackpot" className="hover:text-[#c98bf0] transition-colors">Jackpot</Link></li>
              <li><Link to="/roulette" className="hover:text-[#c98bf0] transition-colors">Roulette</Link></li>
              <li><Link to="/coinflip" className="hover:text-[#c98bf0] transition-colors">Coinflip</Link></li>
              <li><Link to="/blackjack" className="hover:text-[#c98bf0] transition-colors">Blackjack</Link></li>
              <li><Link to="/chicken-road" className="hover:text-[#c98bf0] transition-colors">Chicken Road</Link></li>
              <li><Link to="/tower" className="hover:text-[#c98bf0] transition-colors">Towers</Link></li>
              <li><Link to="/plinko" className="hover:text-[#c98bf0] transition-colors">Plinko</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-zinc-600 font-black uppercase tracking-widest text-xs mb-5">Community</h3>
            <ul className="space-y-3 text-sm text-zinc-400 font-medium">
              <li><Link to="/race" className="hover:text-amber-400 transition-colors flex items-center gap-2"><Trophy className="w-3.5 h-3.5" /> Daily Race</Link></li>
              <li><Link to="/affiliates" className="hover:text-[#2ecf6e] transition-colors flex items-center gap-2"><Users className="w-3.5 h-3.5" /> Affiliates</Link></li>
              <li><Link to="/communitycases" className="hover:text-[#c98bf0] transition-colors flex items-center gap-2"><Boxes className="w-3.5 h-3.5" /> Community Cases</Link></li>
              <li className="pt-4 mt-4 border-t border-[#2A2D31]">
                <a href="https://discord.gg/bloxbets" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#5865F2] transition-colors text-zinc-300 font-bold">
                  <MessageSquare className="w-4 h-4" /> Join Discord
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal / disclaimer bar */}
        <div className="mt-10 pt-6 border-t border-[#2A2D31] flex flex-col gap-3">
          <p className="text-[11px] text-zinc-600 leading-relaxed font-medium max-w-5xl">
            BloxBets is a social arcade and entertainment platform offering games such as MM2 Coinflip, Cases, Case Battles,
            Crash, Roulette, Blackjack, Towers, Plinko, Dice, Mines, Jackpot and Coinflip — built on provably fair rounds,
            purely for entertainment. Please play responsibly. BloxBets is not a gambling operator and is not a casino; no
            real-world money or currency may be deposited, wagered, or withdrawn on this platform, and the in-site balance
            has no real-world value. BloxBets operates independently and is not affiliated with, sponsored by, or endorsed
            by Roblox Corporation or by the creators of Murder Mystery 2. "Murder Mystery 2" and all related item names are
            the property of their respective owners.
          </p>
          <p className="text-[11px] text-zinc-600 font-medium">© {new Date().getFullYear()} BloxBets.com — All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;